import React, { useState, useEffect } from 'react';
import Navbar from './component/pages/Navbar';
import './component/assets/css/style.css';
import Home from './component/pages/Home';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from './component/pages/Contact';
import Video from './component/pages/Video';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Footer from './component/pages/Footer';
import ScrollTopButton from './component/pages/ScrollTopButton';
import OurTeam from './component/pages/OurTeam';
import About from './component/pages/About';
import NewSubmenu1 from './component/pages/newsubmenu1';
import Publications from './component/assets/publications/Publications';
import Blogs from './component/assets/publications/Blogs';
import Litigation from './component/pages/Randself';
import PrivacyPolicy from './component/pages/PrivacyPolicy';
import Terms from './component/pages/Terms';
import LawyerDetails from './component/pages/LawyerDetails';
import Randself from './component/pages/Randself'
function App() {
  // 👉 Popup state
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("disclaimerShown");

    if (!seen) {
      setShowDisclaimer(true);
      sessionStorage.setItem("disclaimerShown", "true");
    }
  }, []);

  // ✅ Accept → permanently hide
  const handleAccept = () => {
    setShowDisclaimer(false);
  };

  // ✅ Decline → 5 sec hide → again show 🔥
  const handleDecline = () => {
    setShowDisclaimer(false);

    setTimeout(() => {
      setShowDisclaimer(true);
    }, 3000);
  };
  return (
    <Router>

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/video" element={<Video />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/about" element={<About />} />
        <Route path="/submenu" element={<NewSubmenu1 />} />
        <Route path="/litigation" element={<Litigation />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/blogs" element={<Blogs />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
           <Route path="/lawyer/:name" element={<LawyerDetails/>} />
           <Route path="/redevelopment" element={<Randself/>} />
           

      </Routes>

      {/* ✅ Disclaimer Popup */}
      {showDisclaimer && (
        <div className="disclaimer-overlay">
          <div className="disclaimer-box">
            <h3>Disclaimer</h3>
            <p>
             The rules of the Bar Council of India prohibit Advocates and Law Firms from soliciting work or advertising in any manner whatsoever. By accessing and using this website, the user expressly acknowledges and confirms the following:

<ol>
  <li>That there has been no advertisement, solicitation, personal communication, invitation, inducement or assurance of any nature whatsoever from Videlicet Law or any of its members to solicit any work through this website;
</li>
  <li>That the user seeks information about Videlicet Law voluntarily and solely for his / her own information and use;</li>
  <li>That the contents of this website are intended only to provide general information relating to the Firm, its areas of practice, publications, research, legal developments and professional activities;</li>
  <li>That no material or information contained on this website shall be construed as legal advice, legal opinion, or substitute for professional consultation;</li>
  <li>That the viewing, downloading or use of any material from this website does not create any Advocate–Client relationship between the user and Videlicet Law;
</li>
  <li>That while due care has been taken in preparing and updating the contents of this website, Videlicet Law shall not be responsible for any reliance placed by the user on the information contained herein and disclaims all liability arising from any acts or omissions based on such information;
</li>
  <li>That all intellectual property rights in relation to the contents, design, articles, publications, logos and material displayed on this website belong exclusively to Videlicet Law unless otherwise stated</li>
</ol>
 </p>
            <p>By clicking on “Accept” or by continuing to browse this website, the user acknowledges having read, understood and agreed to the above Disclaimer and the Terms of Use of this website. </p>

          <div className="button-group d-flex gap-3 justify-content-center">
  <button className="accept-btn" onClick={handleAccept}>
    Accept
  </button>

  <button className="decline-btn" onClick={handleDecline}>
    Decline
  </button>
</div> </div>
        </div>
      )}

      {/* Scroll To Top Button */}
      <ScrollTopButton />

      <Footer />

    </Router>
  );
}

export default App;